












































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

// Components
import SelectField from '@/components/Form/SelectField.vue';
import Alert from '@/components/Global/Alert.vue';

// Services
import BillPay from '@/services/BillPay';
import Brand from '@/services/Brand';
import * as Sentry from '@sentry/browser';
import S from '@/components/Payment/Methods/Source.vue';
import { Source } from '@/common/BillPay';

@Component({
	name: 'TabBilling',
	components: {
		SelectField,
		Alert,
		S,
	},
})
export default class TabBilling extends Vue {
	@Prop() private user: any;
	private Brand: string = Brand;
	private selectedBrand: string = '';
	private sources: Source[] = [];

	@Watch('selectedBrand')
	private watchSelectedBrand() {
		if (this.selectedBrand.length === 0) {
			this.sources = [];
			return;
		}

		this.sources = this.user.billpay[this.selectedBrand].sources;
	}

	get formattedMethods() {
		console.log(this.transformMethods);
		return this.transformMethods.reduce((c, n, i) => {
			if (i % 2 === 0) {
				c.push([]);
			}

			c[c.length - 1].push(n);
			return c;
		}, []);
	}

	get transformMethods() {
		console.log(this.sources);
		return this.sources.map(s => {
			if (s?.bank_account) {
				console.log({ ...s, ...s.bank_account });
				return { ...s, ...s.bank_account };
			} else {
				return { ...s, ...s.card };
			}
		});
	}
}
